import { render, staticRenderFns } from "./beneficiaryinfo.vue?vue&type=template&id=73b80d67"
import script from "./beneficiaryinfo.vue?vue&type=script&lang=js"
export * from "./beneficiaryinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports